module.exports = __webpack_public_path__ + "img/miniprogram_baidu.e567fd80.png";